(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-anuncio"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var pistas = document.querySelectorAll('[id^="bannerPista-"]');
    pistas.forEach(function(pista) {
      var mitad = pista.scrollWidth / 2;
      pista.style.setProperty('--banner-mitad', mitad + 'px');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function() {
    document.querySelectorAll('.bloque-viendo-ahora').forEach(function(el) {
      var contador = el.querySelector('.bloque-viendo-ahora__contador');
      if (!contador) return;
      var min = parseInt(el.dataset.min, 10);
      var max = parseInt(el.dataset.max, 10);
      var intervalo = parseInt(el.dataset.intervalo, 10) * 1000;

      function aleatorio(a, b) {
        return Math.floor(Math.random() * (b - a + 1)) + a;
      }

      setInterval(function() {
        var actual = parseInt(contador.textContent, 10);
        var siguiente;
        do { siguiente = aleatorio(min, max); } while (siguiente === actual);
        contador.textContent = siguiente;
      }, intervalo);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resenas-clientas"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.resenas-clientas').forEach(function(seccion) {
    var pista = seccion.querySelector('.resenas-clientas__pista');
    var botonPrev = seccion.querySelector('[data-rc-prev]');
    var botonNext = seccion.querySelector('[data-rc-next]');
    if (!pista || !botonPrev || !botonNext) return;

    function desplazar(direccion) {
      var tarjeta = pista.querySelector('.resenas-clientas__tarjeta');
      if (!tarjeta) return;
      var estilos = getComputedStyle(pista);
      var espacio = parseFloat(estilos.gap) || 16;
      var distancia = tarjeta.getBoundingClientRect().width + espacio;
      pista.scrollBy({ left: distancia * direccion, behavior: 'smooth' });
    }

    function actualizarEstadoBotones() {
      var maximo = pista.scrollWidth - pista.clientWidth - 2;
      botonPrev.disabled = pista.scrollLeft <= 0;
      botonNext.disabled = pista.scrollLeft >= maximo;
    }

    botonPrev.addEventListener('click', function() {
      desplazar(-1);
    });

    botonNext.addEventListener('click', function() {
      desplazar(1);
    });

    pista.addEventListener('scroll', actualizarEstadoBotones);
    window.addEventListener('resize', actualizarEstadoBotones);
    actualizarEstadoBotones();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resenas-producto"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[id^="resenasTrack-"]').forEach(function(track) {
      var sufijo = track.id.replace('resenasTrack-', '');
      var btnAnterior = document.getElementById('resenasAnterior-' + sufijo);
      var btnSiguiente = document.getElementById('resenassiguiente-' + sufijo);
      var contenedorPuntos = document.getElementById('resenasPuntos-' + sufijo);
      var puntos = contenedorPuntos ? contenedorPuntos.querySelectorAll('.resenas-producto__punto') : [];
      var tarjetas = track.querySelectorAll('.resenas-producto__tarjeta');
      var total = tarjetas.length;
      var indiceActual = 0;

      function porPagina() {
        var w = window.innerWidth;
        if (w >= 990) return 3;
        if (w >= 749) return 2;
        return 1;
      }

      function maxIndice() {
        return Math.max(0, total - porPagina());
      }

      function mover(indice) {
        indiceActual = Math.max(0, Math.min(indice, maxIndice()));
        var porcentaje = (100 / porPagina()) * indiceActual;
        track.style.transform = 'translateX(-' + porcentaje + '%)';
        puntos.forEach(function(p, i) {
          p.classList.toggle('resenas-producto__punto--activo', i === indiceActual);
        });
      }

      if (btnAnterior) btnAnterior.addEventListener('click', function() { mover(indiceActual - 1); });
      if (btnSiguiente) btnSiguiente.addEventListener('click', function() { mover(indiceActual + 1); });

      puntos.forEach(function(p) {
        p.addEventListener('click', function() { mover(parseInt(p.dataset.indice)); });
      });

      window.addEventListener('resize', function() { mover(indiceActual); });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
